var map = {
	"./black.png": 1023,
	"./blue.png": 1024,
	"./brown.png": 1025,
	"./gray.png": 1026,
	"./green.png": 1027,
	"./orange.png": 1028,
	"./pantone-logo.png": 713,
	"./pink.png": 1029,
	"./poc-spinner.png": 670,
	"./purple.png": 1030,
	"./red.png": 1031,
	"./white.png": 1032,
	"./yellow.png": 1033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 714;